import React from 'react';
import styled from 'styled-components/macro';


const Sidebar = ({ className, children, numberLinks }) => (
    <Container className={className}>
        <Inner>
            {children}
        </Inner>
    </Container>
);


export default Sidebar;


const Container = styled.div`
    flex: 0 0 auto;
    z-index: 2;
    
    height: 100%;
    width: 21rem;
    background-color: ${props => props.theme.primary_color};
`;

const Inner = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    > * {
        max-height: ${props => props.numberLinks ? `${100 / props.numberLinks}%` : '100%'};
    }
`;
